<div><button class="close" mat-button (click)="onNoClick()">X</button></div>

<div *ngIf="data.status == 1" style="text-align: center;">
    <img src="{{data.image}}" class="imgSize" />
</div>    

<div *ngIf="data.status == 0">
    <video class="vidSize" controls autoplay disablePictureInPicture controlsList="nodownload noplaybackrate" src="{{data.image}}" type="video/mp4"></video>
</div>
